import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import InstitutionalOverview from "@/components/InstitutionalOverview";
import RiskMitigation from "@/components/RiskMitigation";
import DivisionLogos from "@/components/DivisionLogos";
import TrustSection from "@/components/TrustSection";
import ContactSection from "@/components/ContactSection";
import ClientBar from "@/components/ClientBar";
import Footer from "@/components/Footer";
import AdminPage from "@/components/AdminPage";
import AssessmentPage from "@/components/AssessmentPage";
import AttestationPage from "@/components/AttestationPage";
import ShareScorePage from "@/components/ShareScorePage";

function LandingPage() {
  return (
    <div className="min-h-screen bg-[#050B14]">
      {/* Noise overlay */}
      <div className="noise-overlay" aria-hidden="true" />
      <Header />
      <main>
        <HeroSection />
        <InstitutionalOverview />
        <RiskMitigation />
        <DivisionLogos />
        <TrustSection />
        <ClientBar />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/assessment" element={<AssessmentPage />} />
        <Route path="/attestation" element={<AttestationPage />} />
        <Route path="/score/:submissionId" element={<ShareScorePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
